<div class="card">
  <h5 class="card-header">
    <div class="card-controls float-right">
      <app-grid-filter-input
        [ngModel]="filterValue$ | async"
        #filter
        (keyup)="filterManufacturers(filter.value)"
        style="margin-right: 10px "
      ></app-grid-filter-input>
      <button type="button" (click)="openNewDialog()" class="btn btn-outline-primary btn-sm">
        <i class="far fa-plus"></i> New
      </button>
    </div>
    <div class="card-title">
      Manufacturers <span class="badge badge-pill badge-secondary">{{ (gridData$ | async)?.total }}</span>
    </div>
  </h5>

  <kendo-grid
    [data]="gridData$ | async"
    [rowHeight]="rowHeight"
    style="height: calc(100vh - 180px);"
    [resizable]="true"
    [sortable]="{
      allowUnsort: true,
      mode: 'single'
    }"
    [sort]="sort$ | async"
    [scrollable]="'virtual'"
    [loading]="!(loaded$ | async)"
    [pageable]="true"
    [pageSize]="pageSize"
    [skip]="skip$ | async"
    (sortChange)="sortChange($event)"
    (pageChange)="pageChange($event)"
  >
    <kendo-grid-column field="name" title="Name">
      <ng-template kendoGridCellTemplate let-manufacturer>
        <div>
          <a class="pointer text-primary" (click)="openEditDialog(manufacturer)">
            {{ manufacturer.name }}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [width]="100" title="Actions">
      <ng-template kendoGridCellTemplate let-manufacturer>
        <div class="no-wrap">
          <button
            (click)="openEditDialog(manufacturer)"
            title="Edit"
            type="button"
            class="btn btn-outline-primary btn-sm no-wrap"
          >
            <i class="far fa-edit"></i>
          </button>
          &nbsp;
          <button
            (click)="delete(manufacturer)"
            title="Delete"
            type="button"
            class="btn btn-outline-danger btn-sm no-wrap"
          >
            <i class="far fa-trash-alt"></i>
          </button>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<!-- <div class="card">
  <div class="card-header">
    <button type="button" (click)="openNewDialog()" class="btn btn-outline-primary float-right">New</button>
    Manufacturers
  </div>
  <div class="card-body">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Manufacturer</th>
          <th>Options</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let manufacturer of manufacturers$ | async">
          <td>{{ manufacturer.name }}</td>
          <td>
            <button (click)="deleteManufacturer(manufacturer)" type="button" class="btn btn-outline-danger btn-sm">
              <i class="far fa-trash-alt"></i>
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div> -->
